// extracted by mini-css-extract-plugin
export var active = "_3e-7";
export var container = "_3e-0";
export var evenWidth = "_3e-4";
export var large = "_3e-5";
export var outlet = "_3e-8";
export var slide = "_3e-2";
export var small = "_3e-6";
export var tab = "_3e-3";
export var tabs = "_3e-1";